var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcHeartLevel2 = function SvgIcHeartLevel2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.703 1.337c-1.545-1.544-4.078-1.54-5.628.01L8.042 2.38 7.01 1.347c-1.55-1.55-4.082-1.554-5.627-.01-1.545 1.546-1.541 4.078.01 5.628l1.032 1.033 5.618 5.618 5.618-5.618 1.034-1.033c1.55-1.55 1.554-4.082.009-5.628"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#9CC100",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M13.68.622C12.22-.838 9.827-.834 8.362.63l-.976.976L6.41.63C4.945-.834 2.552-.84 1.092.62c-1.46 1.46-1.456 3.854.01 5.318l.975.976 5.309 5.31 5.309-5.31.976-.976c1.465-1.464 1.468-3.857.009-5.317",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M2.055 3.459a.353.353 0 1 1-.68.192c-.248-.88.3-1.794 1.213-2.053a.353.353 0 0 1 .193.68c-.548.155-.866.686-.726 1.18z",
    mask: "url(#b)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcHeartLevel2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-heart-level-2.8cda151d658351bed6f6f337e0016801.svg";